module.exports = __webpack_public_path__ + "img/8adbedf2b242259dd46d0c125e31442d.png";